import actionCreatorFactory from "typescript-fsa";
import { TokenSchema, HeadquarterUserInfoSchema, FCStaffInfoSchema } from "../../generated";
import { oauth2Api } from "../../helper/api.helper";
import { setToken } from "../../helper/token.helper";
import { LoginModel } from "../../models/login.model";
import { connectWebsocketAction } from "./ws.actions";
import { loggedInErrorState } from "../reducers/auth.reducer";

export enum AuthActonTypes {
  FETCH_USER_INFO = "FETCH_USER_INFO",
  FETCH_ROLES = "FETCH_ROLES",
  FETCH_USER_ROLES = "FETCH_USER_ROLES",
  LOGOUT = "LOGOUT",
}

const actionCreator = actionCreatorFactory();

const fetchUserInfoActions = actionCreator.async<
  { loggingIn: boolean; loggedIn: boolean },
  { token: TokenSchema; userInfo: HeadquarterUserInfoSchema | FCStaffInfoSchema },
  Error | null
>(AuthActonTypes.FETCH_USER_INFO);

export const authActions = {
  fetchUserInfoStarted: fetchUserInfoActions.started,
  fetchUserInfoDone: fetchUserInfoActions.done,
  fetchUserInfoFailed: fetchUserInfoActions.failed,
  logout: actionCreator(AuthActonTypes.LOGOUT),
  sessionInvalidated: actionCreator<string>("SESSION_INVALIDATED"),
  sessionRestoreFailed: actionCreator<{ message: string; token: TokenSchema }>("SESSION_RESTORE_FAILED"),
};

export const fetchUserInfoAction = (token: TokenSchema, login: boolean) => {
  return async (dispatch: Function) => {
    dispatch(
      authActions.fetchUserInfoStarted({
        loggingIn: login,
        loggedIn: !login,
      })
    );
    try {
      if (login) setToken(token);
      const response = await oauth2Api.userInfo({
        headers: {
          Authorization: "Bearer " + token.access_token,
        },
      });
      const userInfo = response.data as HeadquarterUserInfoSchema | FCStaffInfoSchema;
      console.log(userInfo);
      dispatch(
        authActions.fetchUserInfoDone({
          params: { loggingIn: false, loggedIn: true },
          result: { token, userInfo },
        })
      );
      dispatch(errorStateAction.changeStatus(false));

      if (login) {
        dispatch(connectWebsocketAction());
      }
    } catch (err: any) {
      if (err?.response?.status === 401) {
        dispatch(authActions.sessionInvalidated("ログイン状態が無効になりました。再度ログインしてください。"));
      } else {
        const retryMessage = !err?.response || err.response.status >= 500
          ? "通信に失敗しました。接続状況を確認して、もう一度お試しください。"
          : "ログイン状態を確認できませんでした。もう一度お試しください。";
        dispatch(authActions.sessionRestoreFailed({
          message: retryMessage,
          token,
        }));
      }
    }
  };
};

export const getTokenAction = (loginData: LoginModel) => {
  return async (dispatch: Function) => {
    dispatch(
      authActions.fetchUserInfoStarted({
        loggingIn: true,
        loggedIn: false,
      })
    );
    try {
      const tokenResponse = await oauth2Api.token(
        loginData.email,
        loginData.password,
        "password",
        "session-v2-web",
        "headquarter_user",
        undefined,
        { withCredentials: true }
      );

      const token = tokenResponse.data as TokenSchema;
      dispatch(fetchUserInfoAction(token, true));
    } catch (error: any) {
      dispatch(
        authActions.fetchUserInfoFailed({
          params: { loggingIn: false, loggedIn: false },
          error,
        })
      );
    }
  };
};

export const errorStateAction = {
  changeStatus: actionCreator<boolean>("CHANGE_ERROR_STATUS"),
};
